import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  EServiceId,
  // @TODO после эксперимента MONEY-382 переименовать selectPublishTermsService в setPublishTermsService
  selectPublishTermsService as setPublishTermsService,
} from '../../../../../../../../redux/reducers';
import { selectActiveServiceId, selectIsTopServiceUnavailable } from '../../../../../../../../selectors/publishTerms';
import {
  selectBaseAuctionBetByServiceId,
  selectCurrentBet,
  selectIsAutobrokerEnabled,
} from '../../../../../../../../selectors/auction';
import { selectTopAuctionBetPosition } from '../../../../../../../../selectors/betPosition';
import { useIsMobileDevice } from '../../../../../../../../hooks';
import { BetInputContainer } from '../../../../../BetInput';
import { getLeadBetPositionText } from '../../../../utils/getLeadBetPositionText';

import { BetPositionTooltip } from './components/BetPositionTooltip';
import { ServicePrice } from './components/ServicePrice';
import { TopBetService } from './components/TopBetService';
import { StandardService } from './components/StandardService';
import { PremiumService } from './components/PremiumService';
import { getTopBetServiceTitle, formatMoney } from './utils';
import * as styles from './Service.container.css';

interface IProps {
  serviceId: EServiceId;
}

export const ServiceContainer = ({ serviceId }: IProps) => {
  const dispatch = useDispatch();

  const selectedServiceId = useSelector(selectActiveServiceId);
  const baseAuctionBet = useSelector(selectBaseAuctionBetByServiceId(serviceId));
  const currentBet = useSelector(selectCurrentBet);
  const topAuctionBetPosition = useSelector(selectTopAuctionBetPosition);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);
  const isTopServiceUnavailable = useSelector(selectIsTopServiceUnavailable);

  const isMobile = useIsMobileDevice();
  const isCheckedService = serviceId === selectedServiceId;
  const isTopService = serviceId === EServiceId.top;
  const formattedBaseAuctionBet = formatMoney(baseAuctionBet);

  const onCardClick = React.useCallback(() => {
    if (!isCheckedService) {
      dispatch(setPublishTermsService(serviceId));
    }
  }, [isCheckedService, serviceId, dispatch]);

  const topBetServiceTitle = getTopBetServiceTitle(currentBet, baseAuctionBet);

  const serviceProps = {
    checked: isCheckedService,
    onClick: onCardClick,
  };

  // На мобилках позиция отображается внутри PromotionSectionContainer
  const betPosition = !isMobile && isTopService && topAuctionBetPosition && (
    <BetPositionTooltip loading={false}>{getLeadBetPositionText(topAuctionBetPosition)}</BetPositionTooltip>
  );

  const servicePrice = <ServicePrice price={formattedBaseAuctionBet} />;

  if (isAutobrokerEnabled && serviceId === EServiceId.paid) {
    return null;
  }

  return (
    <div className={styles['service-container']}>
      {betPosition}

      {serviceId === EServiceId.top && (
        <TopBetService title={topBetServiceTitle} unavailable={isTopServiceUnavailable} {...serviceProps}>
          {isAutobrokerEnabled || isTopServiceUnavailable ? servicePrice : <BetInputContainer />}
        </TopBetService>
      )}

      {(serviceId === EServiceId.paid || serviceId === EServiceId.free) && (
        <StandardService {...serviceProps}>{servicePrice}</StandardService>
      )}

      {serviceId === EServiceId.premium && <PremiumService {...serviceProps}>{servicePrice}</PremiumService>}
    </div>
  );
};
